export default "__VITE_ASSET__f530bae5__"